var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 2555 l0 -2555 2393 2 2392 3 3 2553 2 2552 -320 0 -320 0 0 -160 0 -160 -320 0 -320 0 0 160 0 160 -1115 0 -1115 0 0 -160 0 -160 -320 0 -320 0 0 160 0 160 -320 0 -320 0 0 -2555z m4470 -480 l0 -1755 -2075 0 -2075 0 0 1755 0 1755 2075 0 2075 0 0 -1755z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 2880 l0 -320 315 0 315 0 0 320 0 320 -315 0 -315 0 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2727 3193 c-4 -3 -7 -147 -7 -320 l0 -313 320 0 320 0 0 320 0 320 -313 0 c-173 0 -317 -3 -320 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3687 3193 c-4 -3 -7 -147 -7 -320 l0 -313 320 0 320 0 -2 318 -3 317 -311 3 c-171 1 -313 -1 -317 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 1920 l0 -320 320 0 320 0 -2 318 -3 317 -317 3 -318 2 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 1920 l0 -320 315 0 315 0 0 320 0 320 -315 0 -315 0 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 1920 l0 -320 320 0 320 0 0 320 0 320 -320 0 -320 0 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3680 1920 l0 -320 320 0 320 0 0 320 0 320 -320 0 -320 0 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 960 l0 -320 318 2 317 3 3 318 2 317 -320 0 -320 0 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 960 l0 -320 315 0 315 0 0 320 0 320 -315 0 -315 0 0 -320z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2720 960 l0 -320 320 0 320 0 0 320 0 320 -320 0 -320 0 0 -320z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cc9babe7e84dd82920236cba5d659078.svg";
export { ForwardRef as ReactComponent };